import React, { useEffect, useRef, useState } from 'react';
import styles from './animated.module.scss';

const AnimatedBox = ({ className, children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [skipAnimation, setSkipAnimation] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const element = boxRef.current;
    if (!element) return;

    const checkInitialVisibility = () => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      
      // Элемент считается видимым, если его верхняя граница выше низа viewport
      // И нижняя граница ниже верха viewport
      const isVisible = rect.top < viewportHeight && rect.bottom > 0;
      return isVisible;
    };

    if (checkInitialVisibility()) {
      setSkipAnimation(true);
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Устанавливаем skipAnimation только после того как анимация завершилась
          setTimeout(() => setSkipAnimation(true), 400 + delay * 1000);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (boxRef.current) observer.observe(boxRef.current);

    return () => {
      if (boxRef.current) observer.unobserve(boxRef.current);
    };
  }, [delay]);

  return (
    <div
      ref={boxRef}
      className={`${styles.box} ${
        skipAnimation ? styles.skipAnimation : isVisible ? styles.visible : ''
      } ${className ?? ''}`}
      style={{ '--delay': `${delay}s` }}
    >
      {children}
    </div>
  );
};

export default AnimatedBox;
